import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { Button, FlexColumn, FlexRowCenter, GridRow, Text } from "designSystem/index";
import { useLocale } from "designSystem/locale";
import { STANDARD_BORDER_STYLE } from "designSystem/styles/style-functions";
import css from "./CustomViewDialogHeaderForSingleCustomView.module.css";
import { SaveButton } from "designSystem/components/button/ValidationButton";
import { CustomViewDialogProps } from "./CustomViewDialog";

const CustomViewDialogHeaderForSingleCustomView: FunctionComponent<CustomViewDialogProps> = observer((props) => {
	const {
		onCancel,
		onSaveAndClose,
	} = props;
	const loc = useLocale();
	return (
		<FlexRowCenter
			borderBottom={STANDARD_BORDER_STYLE}
			className={css.customViewDialogHeaderForSingleCustomView}
			data-csi-automation="CustomViewDialogHeader"
			gap={2}
			px={6}
			py={3}
		>
			<Text
				bold
				res="SelectSomething"
				resParams={[loc.resource("Attributes")]}
				variant="h4"
			/>
			<FlexColumn flexShrink="0">
				<GridRow spacing={2}>
					<Button
						design="link"
						onClick={onCancel}
						res="Cancel"
					/>
					<SaveButton
						design="primary"
						onAction={onSaveAndClose}
					/>
				</GridRow>
			</FlexColumn>
		</FlexRowCenter>
	);
});

export default CustomViewDialogHeaderForSingleCustomView;